module.exports = __webpack_public_path__ + "img/reports.5c02bc81.svg";